import { CSSProperties, JSX } from "react";
import { HeaderContext, SortDirection } from "@tanstack/react-table";
import { StyledHeadCell } from "baseui/table-grid";
import { colors, css, fonts, getGraphColor, glyphs } from "../../../Styles";
import { IdentifiableRow } from "../reactiveTableRenderer";
import { getFrozenColumnStyle } from "../_Tables/getTableStyles";

interface HeadCellProps {
  style: CSSProperties,
  cellValue: string|JSX.Element,
  onClick?: (event: unknown) => void;
  isSorted?: false | SortDirection;
  keyPass: string;
  colorId?: number;
  sortArrow?: boolean
}

export const HeadCell = <T extends IdentifiableRow,>({style, cellValue, onClick, keyPass, isSorted, colorId, column, table, sortArrow}: HeaderContext<T, unknown> & HeadCellProps) => {
  const value = colorId ? <div style={{backgroundColor: getGraphColor(colorId), ...css.colorTag, ...fonts.header, ...fonts.fontSize4, color: colors.whitePrimary}}>{cellValue}</div> : cellValue;
  const combinedStyle = {
    ...style, 
    ...getFrozenColumnStyle(column.getIsPinned(), column.getIsLastColumn("left"), column.getIsFirstColumn("right"), column.getIndex(), table.getVisibleFlatColumns().length, true),
    position: "sticky",
    cursor: onClick ? "pointer" : "default"
  } as CSSProperties
  return (
    <StyledHeadCell  style={combinedStyle} onClick={onClick} key={keyPass}>
      {value}

      {sortArrow && (
        isSorted === "asc" ? 
          <glyphs.Arrow rotate={-90} size={"15px"}/> 
          : isSorted === "desc" ? 
          <glyphs.Arrow rotate={90} size={"15px"}/> 
          : <glyphs.Arrow rotate={90} transparency={0.3} size={"15px"}/> 
      )}
      
    </StyledHeadCell>
  )
}